import {
  ValidatorFn,
  AbstractControl,
  FormGroup,
  FormArray,
  FormControl,
} from '@angular/forms';

export function containsLetter(stringToCheck: string): boolean {
  const regex = new RegExp('^(?=.*[A-Za-z])');
  return regex.test(stringToCheck);
}

export function constainsSpace(stringToCheck: string): boolean {
  return stringToCheck.indexOf(' ') !== -1;
}

export function digitChar(stringToCheck: string): boolean {
  const regex = new RegExp('(?=.*[0-9])');
  return regex.test(stringToCheck);
}

export function minMaxLengthNospaces(): ValidatorFn {
  return (control: AbstractControl) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    let result = false;
    const passwordRegEx = /^\S{8,64}$/;
    result = passwordRegEx.test(control.value);
    return result ? null : { invalidMinMaxPassword: true };
  };
}
export function atleastOneLetter(): ValidatorFn {
  return (control: AbstractControl) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    let result = false;
    const passwordRegEx = /^(?:(?=.*\d)(?=.*[a-zA-Z]){2,}.*)$/;
    result = passwordRegEx.test(control.value);
    return result ? null : { invalidAtleatOnePassword: true };
  };
}
export function acceptSymbols(): ValidatorFn {
  return (control: AbstractControl) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    let result = false;
    const passwordRegEx = /^((?=.*[!_.&@-]).*$)([a-zA-Z\d!_.&@-]*$)/;
    result = passwordRegEx.test(!control.value ? ' ' : control.value);
    return result ? null : { invalidAcceptSymbols: true };
  };
}
export function acceptAtLeastOneSymbols(): ValidatorFn {
  return (control: AbstractControl) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    let result = false;
    const passwordRegEx = /^[a-zA-Z\d!_.&@-]*$/;
    result = passwordRegEx.test(!control.value ? ' ' : control.value);
    return result ? null : { invalidAcceptSymbols: true };
  };
}
export function minOneUpperLower(): ValidatorFn {
  return (control: AbstractControl) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    let result = false;
    const passwordRegEx = /^(?=.*[a-z])(?=.*[A-Z]).*$/;
    result = passwordRegEx.test(control.value);
    return result ? null : { invalidOneUpLower: true };
  };
}
export function maxTwoCharRepeat(): ValidatorFn {
  return (control: AbstractControl) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    let result = false;
    const passwordRegEx = /^(?!.*(.).*\1.*\1).*/;
    result = passwordRegEx.test(!control.value ? '   ' : control.value);
    return result ? null : { invalidMaxTwoCharRepeat: true };
  };
}
export function disallowNameId(excludeItems: string[]): ValidatorFn {
  return (control: AbstractControl) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    let result = false;
    const excludeRegx = excludeItems.join('|');
    let passwordRegEx = new RegExp(excludeRegx, 'i');
    if (!excludeRegx) {
      passwordRegEx = /^\S$/;
    }
    result = !control.value ? false : !passwordRegEx.test(control.value);
    return result ? null : { invalidDisallowNameId: true };
  };
}
export function validateCity(): ValidatorFn {
  return (control: AbstractControl) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    let result = false;
    const cityRegEx =
      /^(?!.*[ ]{2})(?!.*?["]{2})(?!.*?[']{2})(?!.*?[.]{2})(?!.*?[-]{2})[a-zA-Z "'.-]*$/;
    result = cityRegEx.test(control.value);
    return result ? null : { invalidCity: true };
  };
}
export function validateCommaSeperatedNumbers(): ValidatorFn {
  return (control: AbstractControl) => {
    let isValid = true;
    const commaSeperatedRegEx = /^\d+(,\d+)*$/;
    if (control.value) {
      isValid = commaSeperatedRegEx.test(control.value);
    }
    return isValid ? null : { invalidCommaSeparated: true };
  };
}
export function restrictSpecialChar(): ValidatorFn {
  return (control: AbstractControl) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    let result = false;
    const splcharRegEx =
      /^(?!.*[ ]{2})(?!.*?["]{2})(?!.*?[']{2})(?!.*?[.]{2})(?!.*?[-]{2})[a-zA-Z0-9 "'.-]*$/;
    result = splcharRegEx.test(control.value);
    return result ? null : { invalidChar: true };
  };
}

export function duplicatePassword(c: AbstractControl) {
  const pass = c.get('password') as AbstractControl;
  const confirmPass = c.get('confirmPassword') as AbstractControl;
  if (pass.value !== confirmPass.value && confirmPass.value !== '') {
    return { invalidConfirmPassword: true };
  }
  return null;
}

export function duplicateOldPassword(c: AbstractControl) {
  const oldPass = c.get('oldPassword') as AbstractControl;
  const groupOldPass = c.get('passwordGroup.password') as AbstractControl;
  if (oldPass.value === groupOldPass.value && groupOldPass.value !== '') {
    return { invalidOldPassword: true };
  }
  return null;
}

export function validateAllControls(form: FormGroup | FormArray) {
  for (const field of Object.keys(form.controls)) {
    const control = form.get(field);
    if (control instanceof FormControl) {
      control.markAsTouched({ onlySelf: true });
      // eslint-disable-next-line no-empty
      if (control.invalid) {
      }
    } else if (control instanceof FormGroup) {
      validateAllControls(control);
    }
  }
}

export function isIE() {
  const ua = window.navigator.userAgent.toLowerCase();
  return ua.indexOf('msie') !== -1 || ua.indexOf('trident') !== -1;
}
